// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class Assortments extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon viewBox="0 0 24 24" {...this.props}>
                <path d="M17,22H5c-0.5,0-1-0.4-1-1V5c0-0.5-0.4-1-1-1l0,0C2.4,4,2,4.4,2,5v17v1c0,0.5,0.4,1,1,1h1h13c0.5,0,1-0.4,1-1l0,0 C18,22.4,17.6,22,17,22z" />
                <path d="M21,0H7C6.4,0,6,0.4,6,1v18c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V1C22,0.4,21.6,0,21,0z M19.8,6.7l-6.1,7 C13.5,13.9,13.2,14,13,14c0,0,0,0,0,0c-0.3,0-0.5-0.1-0.7-0.3l-2.9-3.1c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l2.2,2.3l5.3-6.2 c0.4-0.4,1-0.5,1.4-0.1C20.1,5.6,20.1,6.2,19.8,6.7z" />
            </SvgIcon>
        );
    }
}
